import React, { FC } from 'react';
import { isString, isArray, map } from 'lodash';
import { time } from 'uniqid';

export interface ErrorProps {
  callout?: boolean;
  errors?: string | string[];
  showError?: boolean;
  className?: string;
  id?: string;
}

export const errorClassName = 'error-clr';

export const Error: FC<ErrorProps> = ({ errors, showError = true, className = '', id = '' }) => {
  const displayError = errors && showError;
  return (
    <div
      aria-atomic="true"
      aria-live="assertive"
      role="alert"
      className={`${displayError ? 'mt-1 ' : ''} d-flex flex-column ${className}`}
      id={id}>
      {displayError && isString(errors) && (
        <span className="error-clr">
          {errors}
        </span>
      )}
      {displayError &&
        isArray(errors) &&
        map(errors, err => (
          <span key={time('err-')} className="error-clr">
            {err}
          </span>
        ))}
    </div>
  );
};

Error.displayName = 'Error';
export default Error;
